import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";

const state = {
  customers: [],
  customersCount: 0,
  loading: false,
  status: null,
  error: null,
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
